/* ============================================================================
   EYVA — v3
   One signature motion (the scan), plus slow reveals and counters.
   Everything ambient was removed on purpose: calm is stillness, not animation.
   ========================================================================== */
   function eyvaIsIPhone() {
    return /iPhone|iPod/.test(navigator.userAgent || "");
  }
  if (eyvaIsIPhone()) document.documentElement.classList.add("eyva-iphone");

  function eyvaUnlockStickyAncestors(el) {
    /* Never touch html/body, and never set overflow-x:clip on ancestors:
       a non-visible overflow-x computes overflow-y to auto on iOS, so the
       ancestor becomes a second scrollport and the sticky pin rocks. */
    var node = el.parentElement;
    while (node && node !== document.documentElement && node !== document.body) {
      if (node instanceof HTMLElement) {
        node.style.overflow = "visible";
        node.style.contain = "none";
      }
      node = node.parentElement;
    }
  }
  
  /* Lock the pin to a pixel height and ignore URL-bar show/hide. innerHeight
     and 100svh both change (or appear to) as chrome animates, which resizes
     the sticky frame mid-gesture and is the up-down bounce in these sections.
     Relock only when the width changes — that is a real rotate/resize. */
  function eyvaLockViewport(force) {
    var w = window.innerWidth;
    if (!force && Math.abs(w - (eyvaLockViewport._w || 0)) < 2) return;
    /* iPhone: ignore URL-bar resizes entirely. Orientationchange passes force. */
    if (!force && document.documentElement.classList.contains("eyva-iphone")) return;
    eyvaLockViewport._w = w;
    var h = window.innerHeight;
    var headerH = parseFloat(getComputedStyle(document.body).getPropertyValue("--header-height")) || 0;
    if (!headerH) {
      var header = document.querySelector("header-component");
      if (header) headerH = Math.round(header.getBoundingClientRect().height);
    }
    var pin = Math.max(120, h - headerH);
    var root = document.documentElement;
    root.style.setProperty("--eyva-vh", h + "px");
    root.style.setProperty("--eyva-header", headerH + "px");
    root.style.setProperty("--eyva-pin", pin + "px");
  }
  /* The journey section script already locked pixels on iPhone. Rewriting
     them when this deferred file loads (URL bar may have moved) is the bounce. */
  if (document.documentElement.classList.contains("eyva-iphone")) {
    eyvaLockViewport._w = window.innerWidth;
  } else {
    eyvaLockViewport(true);
  }
  window.addEventListener("resize", function () { eyvaLockViewport(false); }, { passive: true });
  window.addEventListener("orientationchange", function () {
    setTimeout(function () { eyvaLockViewport(true); }, 400);
  }, { passive: true });
  
  (function eyvaPinOverscroll() {
    var nodes = document.querySelectorAll(".journey, [data-iw]");
    if (!nodes.length) return;
    var ticking = false;
    function sync() {
      ticking = false;
      var view = window.innerHeight || 1;
      var pinned = false;
      for (var i = 0; i < nodes.length; i++) {
        var r = nodes[i].getBoundingClientRect();
        if (r.top <= 1 && r.bottom >= view - 1) { pinned = true; break; }
      }
      document.documentElement.style.overscrollBehaviorY = pinned ? "none" : "";
    }
    window.addEventListener("scroll", function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(sync);
    }, { passive: true });
    sync();
  })();
  
  function eyvaIsCoarseView() {
    return window.matchMedia("(max-width: 900px), (pointer: coarse)").matches;
  }
  
  function eyvaViewH(pin) {
    if (pin && pin.offsetHeight && (eyvaIsCoarseView() || pin.classList.contains("journey__pin"))) {
      return pin.offsetHeight;
    }
    return window.innerHeight;
  }
  
  function eyvaProgress(root, pin) {
    var travel = root.offsetHeight - eyvaViewH(pin);
    if (travel <= 0) return 0;
    return Math.min(Math.max(-root.getBoundingClientRect().top / travel, 0), 1);
  }
  
  (function () {
    "use strict";
  
    var still = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var $ = function (s, c) { return (c || document).querySelector(s); };
    var $$ = function (s, c) { return [].slice.call((c || document).querySelectorAll(s)); };
  
    /* --- reveals --- */
    if (still || !("IntersectionObserver" in window)) {
      $$(".up").forEach(function (e) { e.classList.add("in"); });
    } else {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          /* An element that leaves above the viewport reports isIntersecting
             false and, on its own, would stay at opacity 0 forever — the reveal
             only ever fires on the way IN. That is not hypothetical: land on
             #faq from the nav, restore a scroll position on reload, or fling the
             trackpad, and whole sections above the viewport are permanently
             blank. Anything already scrolled past is revealed immediately,
             without the stagger, since its entrance has been missed. */
          if (!e.isIntersecting) {
            if (e.boundingClientRect.bottom < 0) { e.target.classList.add("in"); io.unobserve(e.target); }
            return;
          }
          var el = e.target, p = el.parentElement;
          var sibs = p ? $$(".up", p).filter(function (s) { return s.parentElement === p; }) : [el];
          el.style.transitionDelay = Math.min(sibs.indexOf(el), 5) * 90 + "ms";
          el.classList.add("in");
          io.unobserve(el);
        });
      }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
      $$(".up").forEach(function (e) { io.observe(e); });
    }
  
    /* --- nav (optional — only when EYVA custom header is present) --- */
    var nav = $("[data-nav]");
    if (nav) {
      var onScroll = function () { nav.classList.toggle("stuck", window.scrollY > 40); };
      onScroll();
      window.addEventListener("scroll", onScroll, { passive: true });
  
      var burger = $("[data-burger]"), drawer = $("[data-drawer]");
      if (burger && drawer) {
        burger.addEventListener("click", function () {
          var open = nav.classList.toggle("open");
          burger.setAttribute("aria-expanded", open ? "true" : "false");
          drawer.hidden = !open;
        });
        $$("a", drawer).forEach(function (a) {
          a.addEventListener("click", function () {
            nav.classList.remove("open");
            burger.setAttribute("aria-expanded", "false");
            drawer.hidden = true;
          });
        });
      }
    }
  
    /* --- count-ups --- */
    function countTo(el, to, suffix) {
      if (!el || !isFinite(to)) return;
      suffix = suffix || "";
      var raw = String(el.getAttribute("data-to") || to);
      var frac = raw.indexOf(".") >= 0 ? (raw.split(".")[1] || "").replace(/\D/g, "") : "";
      var dec = frac.length;
      function fmt(n) {
        if (dec > 0) return Number(n).toFixed(dec);
        return Math.round(n).toLocaleString("en-IN");
      }
      if (still) { el.textContent = fmt(to) + suffix; return; }
      var t0 = null, dur = 1400;
      function f(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min((ts - t0) / dur, 1);
        var e = 1 - Math.pow(1 - p, 3);
        el.textContent = (p < 1 ? fmt(e * to) : fmt(to)) + suffix;
        if (p < 1) requestAnimationFrame(f);
      }
      requestAnimationFrame(f);
    }
    var counted = new WeakSet();
    var nums = $$("[data-count]");
    if (still || !("IntersectionObserver" in window)) {
      nums.forEach(function (n) { countTo(n, parseFloat(n.getAttribute("data-to")), n.getAttribute("data-suffix")); });
    } else {
      var io2 = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting || counted.has(e.target)) return;
          counted.add(e.target);
          countTo(e.target, parseFloat(e.target.getAttribute("data-to")), e.target.getAttribute("data-suffix"));
          io2.unobserve(e.target);
        });
      }, { threshold: 0.6 });
      nums.forEach(function (n) { io2.observe(n); });
    }
  
    /* --- score numbers (data as hero) --- */
    var io3 = ("IntersectionObserver" in window) && !still ? new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        countTo($("[data-n]", e.target), parseInt(e.target.getAttribute("data-value"), 10), "");
        io3.unobserve(e.target);
      });
    }, { threshold: 0.4 }) : null;
    $$("[data-card]").forEach(function (c) {
      if (io3) io3.observe(c);
      else $("[data-n]", c).textContent = c.getAttribute("data-value");
    });
  
    /* --- intelligence meters --- */
    var io4 = ("IntersectionObserver" in window) && !still ? new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("seen"); io4.unobserve(e.target); } });
    }, { threshold: 0.4 }) : null;
    $$("[data-meter]").forEach(function (m) { if (io4) io4.observe(m); else m.classList.add("seen"); });
  
    /* --- THE signature: press-and-hold scan.
           Ring + score advance only while held; release early and the reading
           decays. Holding the button is resting a finger on the device. --- */
    (function scan() {
      var root = $("[data-scan]"); if (!root) return;
      var ring = $("[data-ring]", root), score = $("[data-score]", root),
          status = $("[data-status]", root), btn = $("[data-hold]", root), label = $("[data-label]", root);
      var C = 603.2, TARGET = 84, HOLD = 2600, DECAY = 900;
      var p = 0, holding = false, done = false, auto = false, raf = null, last = null;
  
      /* the instruction has to match the input the visitor actually has:
         "Touch and hold" on touch devices, "Click and hold" on a mouse.
         Detect the pointer, not the screen width — a small window on a laptop
         is still a mouse, and a large tablet is still touch. */
      var coarse = window.matchMedia("(hover: none) and (pointer: coarse)");
      function verb() { return coarse.matches ? "Touch and hold" : "Click and hold"; }
      function idleLabels() {
        if (done || holding) return;
        status.textContent = verb() + " to scan";
        label.textContent = verb();
      }
      if (coarse.addEventListener) coarse.addEventListener("change", idleLabels);
      else if (coarse.addListener) coarse.addListener(idleLabels);
  
      function paint() {
        ring.style.strokeDashoffset = (C * (1 - p)).toFixed(1);
        score.textContent = Math.round(p * TARGET);
      }
      function stop() { if (raf !== null) cancelAnimationFrame(raf); raf = null; last = null; }
      function start() { if (raf === null) { last = null; raf = requestAnimationFrame(tick); } }
      function finish() {
        done = true; holding = false; auto = false; p = 1; paint();
        root.classList.remove("on");
        status.textContent = "Steady & strong today";
        label.textContent = "Hold to scan again";
        stop();
      }
      function tick(ts) {
        if (last === null) last = ts;
        var dt = ts - last; last = ts;
        p += holding ? dt / HOLD : -dt / DECAY;
        p = Math.min(1, Math.max(0, p));
        paint();
        if (p >= 1) return finish();
        if (!holding && p <= 0) { idleLabels(); stop(); return; }
        raf = requestAnimationFrame(tick);
      }
      function hold(isAuto) {
        if (still) return;
        if (done) { done = false; p = 0; paint(); }
        auto = !!isAuto; holding = true;
        root.classList.add("on");
        status.textContent = "Scanning…";
        label.textContent = isAuto ? "Scanning…" : "Keep holding…";
        start();
      }
      function release() {
        if (still || done || auto || !holding) return;
        holding = false; root.classList.remove("on");
        status.textContent = "Hold to finish the scan"; label.textContent = verb();
        start();
      }
  
      btn.addEventListener("pointerdown", function () { hold(false); });
      ["pointerup", "pointerleave", "pointercancel"].forEach(function (ev) { btn.addEventListener(ev, release); });
      window.addEventListener("pointerup", function () { if (holding && !auto) release(); });
      btn.addEventListener("keydown", function (e) { if (e.key === " " || e.key === "Enter") { e.preventDefault(); if (!holding) hold(false); } });
      btn.addEventListener("keyup", function (e) { if (e.key === " " || e.key === "Enter") { e.preventDefault(); release(); } });
  
      if (still) { p = 1; done = true; paint(); status.textContent = "Steady & strong today"; label.textContent = "Hold to scan again"; return; }
      paint();
      idleLabels();
      if ("IntersectionObserver" in window) {
        var kicked = false;
        var io5 = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (!e.isIntersecting || kicked) return;
            kicked = true; io5.disconnect();
            setTimeout(function () { if (!done && !holding) hold(true); }, 700);
          });
        }, { threshold: 0.4 });
        io5.observe(root);
      } else hold(true);
    })();
  
    /* --- hero scan stage ----------------------------------------------------
       The entire animation is CSS; this only flips one state class, so there is
       no per-frame JS in the hero at all.
  
         (none)        rest — rings empty, nothing moving
         .is-scanning  ripples run, both rings sweep 0→100% over 5s
         .is-done      rings hold at 100%, ripples stop, the reading arrives
  
       Nothing starts on load: the button is the only trigger. Measurement still
       waits on the photograph decoding, because the rings and the button are
       positioned against the photograph's real box, not the hero's. */
    /* --- where is a cover-fitted photograph, really? -------------------------
       An object-fit:cover image renders larger than its box and slides around as
       the viewport's aspect ratio changes. Nothing in CSS exposes that box, so
       this reproduces the cover maths and publishes it on `target` as
       --fit-x/y/w/h. Marks are then positioned as fractions of the PHOTOGRAPH
       rather than of its container, which is the only way they stay welded to
       what they point at.
  
       object-position is read back from the computed style rather than
       hardcoded, so a responsive override cannot desync it.
  
       Shared by the hero's scan layer and the journey's step-2 ripples. */
    function coverFit(img, base, target) {
      var box = img.getBoundingClientRect(), origin = base.getBoundingClientRect();
      var cw = img.clientWidth, ch = img.clientHeight;
      var nw = img.naturalWidth, nh = img.naturalHeight;
      if (!cw || !ch || !nw || !nh) return;
  
      var p = getComputedStyle(img).objectPosition.split(" ");
      var ox = parseFloat(p[0]), oy = parseFloat(p[1]);
      if (isNaN(ox)) ox = 50;
      if (isNaN(oy)) oy = 50;
  
      var s = Math.max(cw / nw, ch / nh);   /* cover: the larger of the two */
      var w = nw * s, h = nh * s;
  
      target.style.setProperty("--fit-x", (box.left - origin.left + (cw - w) * ox / 100) + "px");
      target.style.setProperty("--fit-y", (box.top - origin.top + (ch - h) * oy / 100) + "px");
      target.style.setProperty("--fit-w", w + "px");
      target.style.setProperty("--fit-h", h + "px");
    }
  
    /* the gut's travelling light is SMIL, which no media query can switch off.
       Under reduced motion the element is removed, leaving the shape lit by a
       static gradient. */
    if (still) {
      $$("[data-gut-flow]").forEach(function (a) { a.remove(); });
    }
  
    /* --- the journey's ripples ----------------------------------------------
       Steps 1 and 2 both carry a scan layer, each welded to its own
       photograph's thumbs. Same measurement and same components as the hero.
       CSS decides when they run (only while their slide is the active step);
       this only keeps them in place.
  
       Every layer is measured independently — the two slides serve different
       files with different intrinsic sizes, and below 860px they each swap to
       their own 3:4 crop, so one shared measurement would put step 1's marks
       wherever step 2's photograph happened to be. */
    $$("[data-jscan]").forEach(function (layer) {
      var media = layer.closest(".jslide__media"), shot = $("img", media);
      if (!media || !shot) return;
  
      var queued = false;
      function refit() {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () { queued = false; coverFit(shot, media, layer); });
      }
      window.addEventListener("resize", refit, { passive: true });
      if ("ResizeObserver" in window) new ResizeObserver(refit).observe(media);
      /* the <source> swap at 860px is a different crop with a different
         intrinsic size, so a breakpoint change has to be re-measured */
      shot.addEventListener("load", refit);
      if (shot.complete && shot.naturalWidth) refit();
    });
  
    (function scanStage() {
      var stage = $("[data-scan-stage]"); if (!stage) return;
      var hero = stage.closest(".hero"), shot = $(".hero__img img", hero);
      if (!hero || !shot) return;
  
      /* --- where is the photograph, really? ---------------------------------
         The hero image is object-fit:cover, so its rendered box is larger than
         the hero and slides around as the viewport's aspect ratio changes.
         Nothing in CSS exposes that box, so we reproduce the cover maths and
         publish it as custom properties. The scan marks are then positioned as
         fractions of the PHOTOGRAPH rather than of the hero, which is the only
         way they stay on the thumbs at every size.
  
         object-position is read back from the computed style rather than
         hardcoded here, so the responsive override at 860px cannot desync it. */
      /* measured off the <img> itself, not off .hero: on desktop the photograph
         is the hero's full-bleed background, but below 860px it leaves that
         layer and becomes a block stacked under the copy. Reading its real box
         means one set of maths serves both layouts. .scan is inset:0 of .hero,
         so the box is expressed relative to the hero's own origin.
  
         Published on .hero rather than on .scan because the reading card lives
         in .hero__deck — a SIBLING of .scan — and has to centre on the same
         button. Custom properties inherit, so the scan layer still resolves
         them exactly as before. */
      function fit() { coverFit(shot, hero, hero); }
  
      /* rAF-coalesced: resize fires in bursts, and this writes four custom
         properties that each invalidate layout for the marks */
      var queued = false;
      function refit() {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () { queued = false; fit(); });
      }
      window.addEventListener("resize", refit, { passive: true });
      /* the hero for viewport changes, the photograph for the stacked mobile
         layout — where a late webfont reflowing the copy moves the image without
         the hero itself changing size */
      if ("ResizeObserver" in window) {
        var ro = new ResizeObserver(refit);
        ro.observe(hero); ro.observe(shot);
      }
      /* the mobile <source> is a different crop with a different intrinsic size,
         so a breakpoint swap has to be re-measured */
      shot.addEventListener("load", refit);
  
      /* --- the scan, on demand ------------------------------------------------
         Nothing here runs on load. The button is the only trigger, and while a
         scan is running it is inert — repeated presses are ignored rather than
         queued or restarting the sweep.
  
         The 5s fill and the 400ms hold at 100% are CSS; JS only moves the state
         class and never touches geometry, so there is nothing per-frame to drop.
         SCAN_MS must stay in step with the transition on .scan.is-scanning
         .scan__prog in index.css — halved to 5s on 2026-08-06 when the hero
         animation was doubled in speed. */
      var SCAN_MS = 5000, HOLD_MS = 400;
      var btn = $("[data-scan-btn]", stage),
          label = $("[data-scan-label]", stage),
          status = $("[data-scan-status]", stage);
      var running = false, timers = [];
  
      function say(t) { if (status) status.textContent = t; }
      function setLabel(t) { if (label) label.textContent = t; }
      function clearTimers() { timers.forEach(clearTimeout); timers = []; }
  
      /* --- the completion chime (2026-08-06) --------------------------------
         A soft "ting" as the reading arrives — synthesised inline, no asset.
         Two sine strikes a fifth apart (C6 then G6, the second 90ms behind)
         with a near-instant attack and a long exponential decay, plus a quiet
         octave partial on the first for bell brightness. Peaks stay under .05
         so it reads as a notification, not an alert. The context is created in
         run(), inside the click — browsers only allow audio after a gesture —
         so the chime can never sound on load or on scroll. */
      var actx = null;
      function chime() {
        if (!actx || actx.state !== "running") return;
        var t0 = actx.currentTime + 0.02;
        [[1046.5, 0, .045, 1.4], [2093.0, 0, .012, .9], [1568.0, .09, .03, 1.6]]
          .forEach(function (n) {
            var at = t0 + n[1], o = actx.createOscillator(), g = actx.createGain();
            o.type = "sine"; o.frequency.value = n[0];
            g.gain.setValueAtTime(0.0001, at);
            g.gain.exponentialRampToValueAtTime(n[2], at + 0.015);
            g.gain.exponentialRampToValueAtTime(0.0001, at + n[3]);
            o.connect(g); g.connect(actx.destination);
            o.start(at); o.stop(at + n[3] + 0.05);
          });
      }
  
      function finish() {
        running = false;
        stage.classList.remove("is-scanning");
        stage.classList.add("is-done");
        setLabel("Scan again");
        say("Scan complete. Metabolic 76, cardiovascular 82, respiratory 86.");
        chime();
      }
  
      function run() {
        if (running) return;              /* ignore presses mid-scan */
        running = true;
        clearTimers();
  
        /* first press births the audio context (a gesture is required); later
           presses just wake it if the tab suspended it */
        if (!actx && "AudioContext" in window) {
          try { actx = new AudioContext(); } catch (e) { actx = null; }
        }
        if (actx && actx.state === "suspended") actx.resume();
  
        /* leaving .is-done drops the rings back to empty with no transition
           (see styles.css), and the reflow guarantees the browser paints that
           zero state before the new sweep is asked for — without it the ring
           would animate from 100% to 100% and appear frozen */
        stage.classList.remove("is-done");
        void stage.offsetWidth;
  
        if (still) { finish(); return; }  /* no sweep, but the press still counts */
  
        stage.classList.add("is-scanning");
        setLabel("Scanning…");
        say("Scanning. This takes about ten seconds.");
        /* the ring holds at 100% for HOLD_MS before the reading arrives */
        timers.push(setTimeout(finish, SCAN_MS + HOLD_MS));
      }
  
      if (btn) btn.addEventListener("click", run);
  
      /* the marks cannot be placed until the photograph reports its intrinsic
         size, so measurement waits on decode — and still runs if it never loads.
         This positions the button and the rings; it does NOT start anything. */
      if (shot.complete && shot.naturalWidth) {
        fit();
      } else {
        shot.addEventListener("load", fit, { once: true });
        shot.addEventListener("error", fit, { once: true });
      }
    })();
  
    /* --- the journey ---------------------------------------------------------
       Vertical scroll, read as lateral movement. The section is three screens
       tall and its pin sticks for all of it, so progress through those screens
       maps 1:1 onto how far the track has travelled.
  
       Deliberately NOT a scroll hijack: no wheel/touch listeners, no forced
       scrollTo, no animation loop running when nothing has changed. The track is
       only ever exactly where the reader has scrolled to, which is why the
       document's own scroll-snap can stay in charge of where a gesture lands. */
    (function journey() {
      var root = $(".journey"), track = $("[data-journey-track]");
      if (!root || !track) return;
      var COUNT = $$(".jslide", track).length;
      if (still || COUNT < 2) return;   /* stacked by the reduced-motion rules */
      eyvaUnlockStickyAncestors(root);
      var pin = $(".journey__pin", root);
      /* iOS position:sticky jitters as the URL bar moves. Drive the pin with
         position:fixed while the section is in range so the slides still
         scrub sideways from vertical scroll, without the frame bouncing. */
      var ios = eyvaIsIPhone();
      var step = 0, ticking = false, pinMode = "";
  
      /* Slides 2 and 3 are translated outside the pin's overflow, so they never
         intersect the viewport and the browser's lazy-loading heuristic never
         fires for them — they would arrive blank and pop in. Flipping loading to
         eager starts the fetch, so they are warmed one screen ahead instead of
         being paid for on the initial load. */
      (function warmSlides() {
        var pending = $$('img[loading="lazy"]', track);
        if (!pending.length || !("IntersectionObserver" in window)) return;
        var io = new IntersectionObserver(function (es) {
          if (!es[0].isIntersecting) return;
          io.disconnect();
          pending.forEach(function (im) { im.loading = "eager"; });
        }, { rootMargin: "100% 0px" });
        io.observe(root);
      })();
  
      function headerPx() {
        return parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--eyva-header")) || 0;
      }

      function frame() {
        ticking = false;
        var p;
        if (ios && pin) {
          var box = root.getBoundingClientRect();
          var pinH = pin.offsetHeight || 1;
          var hh = headerPx();
          var travel = root.offsetHeight - pinH;
          /* 2px hysteresis stops mode flapping (rel↔fix↔abs) that reads as a
             vertical rock while the iOS URL bar animates mid-gesture. */
          var start = hh;
          var finish = hh - travel;
          var mode;
          if (pinMode === "fix") {
            mode = box.top >= start + 2 ? "rel" : box.top <= finish - 2 ? "abs" : "fix";
          } else if (pinMode === "rel") {
            mode = box.top < start - 2 ? (box.top <= finish ? "abs" : "fix") : "rel";
          } else if (pinMode === "abs") {
            mode = box.top > finish + 2 ? (box.top >= start ? "rel" : "fix") : "abs";
          } else {
            mode = box.top >= start ? "rel" : box.top <= finish ? "abs" : "fix";
          }
          if (mode !== pinMode) {
            pinMode = mode;
            if (mode === "rel") {
              pin.style.position = "relative";
              pin.style.top = "0px";
              pin.style.bottom = "auto";
              pin.style.left = "";
              pin.style.right = "";
              pin.style.width = "";
            } else if (mode === "abs") {
              pin.style.position = "absolute";
              pin.style.top = "auto";
              pin.style.bottom = "0px";
              pin.style.left = "0px";
              pin.style.right = "0px";
              pin.style.width = "auto";
            } else {
              pin.style.position = "fixed";
              pin.style.top = hh + "px";
              pin.style.bottom = "auto";
              /* Match section horizontal bounds — not full viewport —
                 so the pin does not jump sideways when mode flips. */
              pin.style.left = Math.round(box.left) + "px";
              pin.style.right = "auto";
              pin.style.width = Math.round(box.width) + "px";
            }
          } else if (mode === "fix") {
            /* Keep left/width synced if the visual viewport shifts. */
            var nextLeft = Math.round(box.left) + "px";
            var nextWidth = Math.round(box.width) + "px";
            if (pin.style.left !== nextLeft) pin.style.left = nextLeft;
            if (pin.style.width !== nextWidth) pin.style.width = nextWidth;
          }
          p = travel <= 0 ? 0 : Math.min(Math.max((hh - box.top) / travel, 0), 1);
        } else {
          p = eyvaProgress(root, pin);
        }
        /* % of the pin, never vw: 100vw on iOS is wider than the visual viewport
           and a 300vw track rubber-bands the page sideways while you scroll. */
        track.style.setProperty("--slide-x", -(p * (COUNT - 1) * 100) + "%");
  
        /* round to the nearest slide so the indicator flips at the halfway
           point rather than the instant the track starts moving */
        var now = Math.min(COUNT, Math.round(p * (COUNT - 1)) + 1);
        if (now !== step) {
          step = now;
          root.setAttribute("data-step", now);   /* the ticks read off this */
        }
      }
  
      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(frame);
      }
  
      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", onScroll, { passive: true });
      frame();
    })();
  
    /* --- the widget deck ----------------------------------------------------
       THE STACKING IS NOT HERE. Every card is position:sticky at its own pin
       offset, so they come to rest on top of one another with no script at all
       — switch JavaScript off and the deck still deals itself. That is the
       whole point of the rewrite: the previous version computed every card's
       position in this handler, so anything that stopped the handler running
       left three cards in a column.
  
       What this adds is depth and the legend:
         --sc     covered cards shrink slightly
         --lift   and lose their shadow with them
         is-on    the sentence under the deck follows the top card
  
       "Arrived" is measured per card as how close it is to its own pin, ramped
       over half a viewport, so depth is continuous rather than stepped — the
       deck settles as you scroll instead of snapping. Reversing is free: every
       value is a function of the current position, not of what happened last. */
    (function deck() {
      var root = $("[data-stack]"); if (!root) return;
      var cards = $$("[data-wcard]", root), legs = $$("[data-sleg]", root);
      if (cards.length < 2) return;
  
      var N = cards.length, at = -1, ticking = false, counted = [];
  
      function pinOf(c) { return parseFloat(getComputedStyle(c).top) || 0; }
  
      function runTicks(c) {
        if (counted.indexOf(c) > -1) return;
        counted.push(c);
        $$("[data-tick]", c).forEach(function (n) {
          countTo(n, parseFloat(n.getAttribute("data-to")), n.getAttribute("data-suffix"));
        });
      }
  
      function frame() {
        ticking = false;
        var ramp = window.innerHeight * 0.55, arrived = [], i, j;
  
        for (i = 0; i < N; i++) {
          var d = cards[i].getBoundingClientRect().top - pinOf(cards[i]);
          arrived[i] = 1 - Math.min(Math.max(d / ramp, 0), 1);
        }
  
        var top = 0;
        for (i = 0; i < N; i++) {
          var depth = 0;
          for (j = i + 1; j < N; j++) depth += arrived[j];
          cards[i].style.setProperty("--sc", (1 - 0.022 * depth).toFixed(4));
          cards[i].style.setProperty("--lift", (1 - 0.42 * depth).toFixed(3));
          /* the topmost card that has actually landed owns the legend */
          if (arrived[i] > 0.5) top = i;
          /* count up a little before it lands, so the number is settled by the
             time the card is the one being read */
          if (arrived[i] > 0.25) runTicks(cards[i]);
        }
  
        if (top !== at) {
          at = top;
          for (i = 0; i < legs.length; i++) legs[i].classList.toggle("is-on", i === top);
        }
      }
  
      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(frame);
      }
      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", onScroll, { passive: true });
      frame();
    })();
  
    /* --- the score showcase --------------------------------------------------
       Scroll picks which of N scores is active (equal travel shares). The phone
       card flips on the Y axis when the index changes; copy cross-fades. A tap
       on the phone advances to the next score and scrolls into that share so
       the sticky stage and the flip stay in sync. */
    (function showcase() {
      var root = $("[data-show]"); if (!root) return;
      var phone = $(".show__phone", root);
      var shots = $$("[data-sshot]", root), blocks = $$("[data-sblock]", root);
      var N = Math.min(shots.length, blocks.length);
      if (N < 2) return;
  
      var at = -1, ticking = false, flipping = false, counted = [];
      /* iOS Safari smears text/SVG under rotateY + preserve-3d (device shot
         2026-09-03). Keep the interactive swap; drop the 3D flip on iPhone. */
      root.classList.add(eyvaIsIPhone() ? "show--safe" : "show--flip");
  
      function clearInline(el) {
        if (!el) return;
        el.style.opacity = "";
        el.style.transform = "";
        el.style.pointerEvents = "";
      }
  
      function settle(card) {
        if (counted.indexOf(card) > -1) return;
        counted.push(card);
        card.classList.add("is-settled");
        var bi = shots.indexOf(card);
        if (bi >= 0 && blocks[bi]) blocks[bi].classList.add("is-settled");
        var n = $("[data-show-n]", card);
        if (!n) return;
        var to = parseFloat(n.getAttribute("data-to"));
        if (!isFinite(to)) return;
        n.textContent = still ? String(Math.round(to)) : "0";
        countTo(n, to, "");
      }
  
      function showIndex(i, dir) {
        i = Math.min(N - 1, Math.max(0, i));
        if (i === at) return;
        var prev = at;
        at = i;
        dir = dir || (prev < 0 ? 0 : i > prev ? 1 : -1);
  
        for (var k = 0; k < N; k++) {
          clearInline(blocks[k]);
          clearInline(shots[k]);
          if (blocks[k]) {
            blocks[k].classList.toggle("is-on", k === i);
            blocks[k].classList.remove("is-flip-out", "is-flip-in", "is-flip-out-rev", "is-flip-in-rev");
          }
          if (shots[k]) {
            shots[k].classList.remove("is-on", "is-flip-out", "is-flip-in", "is-flip-out-rev", "is-flip-in-rev");
          }
        }
  
        if (still || prev < 0 || !dir) {
          if (blocks[i]) blocks[i].classList.add("is-on");
          if (shots[i]) {
            shots[i].classList.add("is-on");
            settle(shots[i]);
          }
          return;
        }
  
        flipping = true;
        var outCls = dir > 0 ? "is-flip-out" : "is-flip-out-rev";
        var inCls = dir > 0 ? "is-flip-in" : "is-flip-in-rev";
        if (shots[prev]) {
          shots[prev].classList.add("is-on", outCls);
        }
        if (shots[i]) {
          shots[i].classList.add("is-on", inCls);
        }
        if (blocks[i]) blocks[i].classList.add("is-on");
  
        window.setTimeout(function () {
          if (shots[prev]) {
            shots[prev].classList.remove("is-on", outCls);
          }
          if (shots[i]) {
            shots[i].classList.remove(inCls);
            settle(shots[i]);
          }
          flipping = false;
        }, eyvaIsIPhone() ? 560 : 720);
      }
  
      function indexFromScroll() {
        var travel = root.offsetHeight - window.innerHeight;
        if (travel <= 0) return 0;
        var p = Math.min(Math.max(-root.getBoundingClientRect().top / travel, 0), 1);
        var i = Math.min(N - 1, Math.floor(p * N));
        /* Hysteresis so the active score does not chatter at share edges —
           that was reading as a left/right bounce on iPhone. */
        if (at >= 0 && i !== at) {
          var enter = (at + (i > at ? 0.72 : 0.28)) / N;
          if (i > at && p < enter) return at;
          if (i < at && p > enter) return at;
        }
        return i;
      }
  
      function scrollToIndex(i) {
        var travel = root.offsetHeight - window.innerHeight;
        if (travel <= 0) return;
        var p = (i + 0.5) / N;
        var top = root.getBoundingClientRect().top + window.pageYOffset + p * travel;
        /* Smooth scroll on iOS rubber-bands the sticky stage; jump instead. */
        window.scrollTo({
          top: top,
          behavior: (still || eyvaIsIPhone()) ? "auto" : "smooth"
        });
      }
  
      function frame() {
        ticking = false;
        if (flipping) return;
        showIndex(indexFromScroll());
      }
  
      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(frame);
      }
  
      if (phone) {
        phone.setAttribute("role", "button");
        phone.setAttribute("tabindex", "0");
        phone.setAttribute("aria-label", "Flip to the next wellness score");
        phone.style.cursor = "pointer";
        function advance() {
          var next = (Math.max(at, 0) + 1) % N;
          showIndex(next, 1);
          scrollToIndex(next);
        }
        phone.addEventListener("click", advance);
        phone.addEventListener("keydown", function (e) {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            advance();
          }
        });
      }
  
      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", onScroll, { passive: true });
      frame();
    })();
  
    /* --- moments track ------------------------------------------------------
       The track scrolls perfectly well without this — it is a native overflow
       container with scroll-snap, so touch, trackpad, keyboard and a dragged
       scrollbar all already work. This only adds the two arrows, and keeps them
       honest about whether there is anything left in that direction. */
    (function moments() {
      $$("[data-mtrack]").forEach(function (track) {
        var wrap = track.parentElement;
        if (!wrap) return;
        var prev = $("[data-mprev]", wrap);
        var next = $("[data-mnext]", wrap);
        if (!prev || !next) return;
  
        /* one card plus one gap, measured rather than assumed — the card is a
           clamp() and the gap is a token, so both change with the viewport */
        function stride() {
          var card = $(".mcard", track);
          if (!card) return track.clientWidth;
          var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          return card.getBoundingClientRect().width + gap;
        }
  
        function sync() {
          /* the 2px slack absorbs sub-pixel scroll positions, which otherwise
             leave "next" enabled forever at the far end */
          var max = track.scrollWidth - track.clientWidth;
          prev.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= max - 2;
        }
  
        prev.addEventListener("click", function () { track.scrollBy({ left: -stride(), behavior: still ? "auto" : "smooth" }); });
        next.addEventListener("click", function () { track.scrollBy({ left: stride(), behavior: still ? "auto" : "smooth" }); });
        track.addEventListener("scroll", sync, { passive: true });
        window.addEventListener("resize", sync, { passive: true });
        sync();
      });
    })();
  
    /* --- FAQ --- */
    var faq = $("[data-faq]");
    if (faq) {
      var items = $$(".faq__i", faq);
      items.forEach(function (it) {
        var b = $(".faq__q", it);
        b.addEventListener("click", function () {
          var open = it.classList.contains("open");
          items.forEach(function (o) { if (o !== it) { o.classList.remove("open"); $(".faq__q", o).setAttribute("aria-expanded", "false"); } });
          it.classList.toggle("open", !open);
          b.setAttribute("aria-expanded", !open ? "true" : "false");
        });
      });
    }
  
    /* --- reserve form --- */
    var form = $("[data-form]");
    if (form) {
      var note = $("[data-note]"), input = $("input", form);
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test((input.value || "").trim())) {
          note.textContent = "Please enter a valid email so we can reach you.";
          note.classList.remove("ok"); input.focus(); return;
        }
        note.textContent = "You're on the list — we'll be in touch when your EYVA is ready.";
        note.classList.add("ok"); input.value = ""; input.blur();
      });
    }
  })();
  
  /* ══ 06c THE OBJECT — the studio pass ═══════════════════════════════════════
     Appended 2026-07-22 as its own IIFE (the main closure above is sealed).
     Same contract as journey(): the section is N screens tall, the stage is
     sticky, and scroll progress drives everything. Each frame's opacity is a
     smoothstepped tent around its own beat, so exactly one crossfade is ever
     in flight; the scale/translate drift is what makes a cut read as the
     camera settling instead of a slideshow tick. */
  (function studio() {
    var root = document.querySelector(".studio");
    if (!root) return;
    eyvaUnlockStickyAncestors(root);
    var frames = [].slice.call(root.querySelectorAll("[data-studio-frame]"));
    var lines = [].slice.call(root.querySelectorAll("[data-studio-line]"));
    var ticks = [].slice.call(root.querySelectorAll(".studio__rail i"));
    var N = frames.length;
    if (N < 2) return;
  
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      root.classList.add("studio--flat");   /* one still, five readable lines */
      return;
    }
  
    var ticking = false, cur = 0;
    function frame() {
      ticking = false;
      var box = root.getBoundingClientRect();
      var travel = root.offsetHeight - window.innerHeight;
      if (travel <= 0) return;
      var p = Math.min(Math.max(-box.top / travel, 0), 1);
      var x = p * (N - 1);
      for (var i = 0; i < N; i++) {
        var d = 1 - Math.min(Math.abs(x - i), 1);
        var o = d * d * (3 - 2 * d);
        frames[i].style.opacity = o;
        /* settle: sharpest (scale 1.01) at the beat's centre, drifting +-12px
           vertically as it hands over — the "camera" never fully stops */
        frames[i].style.transform =
          "scale(" + (1.06 - 0.05 * d).toFixed(4) + ") translateY(" + ((i - x) * 12).toFixed(1) + "px)";
      }
      var now = Math.round(x);
      if (now !== cur) {
        cur = now;
        lines.forEach(function (l, i) { l.classList.toggle("on", i === now); });
        ticks.forEach(function (t, i) { t.classList.toggle("on", i === now); });
      }
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    frame();
  })();
  
  /* ══ 06d UP CLOSE — the hotspot explorer ════════════════════════════════════
     One card at a time; ESC and click-outside close. The cards live on a deck
     ABOVE the stage (see the markup note) rather than inside their pins, so a
     pin toggles aria-expanded on itself and .on on its card — matched by
     index. aria-controls ties each pin to its card for assistive tech. */
  (function explore() {
    var root = document.querySelector("[data-explore]");
    if (!root) return;
    var spots = [].slice.call(root.querySelectorAll("[data-spot]"));
    var cards = [].slice.call(root.querySelectorAll(".spot__card"));
    var links = [].slice.call(root.querySelectorAll("[data-spot-link]"));
    function closeAll() {
      spots.forEach(function (s) { s.setAttribute("aria-expanded", "false"); });
      cards.forEach(function (c) { c.classList.remove("on"); });
      links.forEach(function (l) { l.classList.remove("on"); });
    }
    spots.forEach(function (s, i) {
      s.addEventListener("click", function (e) {
        e.stopPropagation();
        var open = s.getAttribute("aria-expanded") === "true";
        closeAll();
        if (!open) {
          s.setAttribute("aria-expanded", "true");
          if (cards[i]) cards[i].classList.add("on");
          if (links[i]) links[i].classList.add("on");
        }
      });
    });
    document.addEventListener("click", function (e) {
      if (!root.contains(e.target)) closeAll();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeAll();
    });
  })();
  
  (function () {
    "use strict";
    if (matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    var qa = function (s, c) { return [].slice.call((c || document).querySelectorAll(s)); };
  
    function stage(root, groups) {
      if (!root) return;
      eyvaUnlockStickyAncestors(root);
      var pin = root.querySelector(".iws__stage");
      var N = Math.min.apply(null, groups.map(function (g) { return g.length; }));
      if (N < 2) return;
      var at = -1, ticking = false;
      function frame() {
        ticking = false;
        var p = eyvaProgress(root, eyvaIsCoarseView() ? pin : null);
        var i = Math.min(N - 1, Math.floor(p * N));
        if (i === at) return;
        at = i;
        groups.forEach(function (g) {
          for (var k = 0; k < g.length; k++) g[k].classList.toggle("is-on", k === i);
        });
      }
      function onScroll() { if (ticking) return; ticking = true; requestAnimationFrame(frame); }
      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", onScroll, { passive: true });
      frame();
    }
  
    var iw = document.querySelector("[data-iw]");
    /* the section's wash is a third group: it lives OUTSIDE [data-iw] (it has to
       cover the whole of #intel, heading included), which is fine â€” stage() only
       measures `root`, the groups are any elements you hand it. */
    stage(iw, [ qa("[data-iw-card]", iw), qa("[data-iw-txt]", iw), qa("[data-iw-bg]") ]);
  })();
  
  (function () {
    "use strict";
    var root = document.querySelector("[data-aisc]");
    if (!root) return;
    if (matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    /* the stacked layout ships the finished composition â€” no pin, no typing */
    /* must match the stacked breakpoint in index.css */
    var mqStack = matchMedia("(max-width:1279px)");
    var stage = root.querySelector(".aisc__stage");
    var vis = stage.querySelector("[data-ait]");
    var FINAL = vis.innerHTML;   /* full markup, gleam included */
    /* three lines, broken before the gleam phrase (annotated brief) */
    var L1 = "It doesn't just track.";
    var L2 = "It tells you";
    var L3 = "what to do next.";
    var ticking = false, typed = false, timers = [];
  
    function clearTimers() { timers.forEach(clearTimeout); timers = []; }
    /* the headline types line by line once the mark has settled; the final
       write swaps in the real markup so the gleam phrase takes over */
    function typeIn() {
      typed = true; clearTimers();
      stage.classList.add("is-typing");
      var i = 0, j = 0, k = 0;
      vis.innerHTML = "";
      (function stepL1() {
        if (i < L1.length) {
          i++; vis.textContent = L1.slice(0, i);
          timers.push(setTimeout(stepL1, 30 + (i % 4) * 9));
        } else {
          timers.push(setTimeout(stepL2, 260));
        }
      })();
      function stepL2() {
        if (j < L2.length) {
          j++; vis.innerHTML = L1 + "<br>" + L2.slice(0, j);
          timers.push(setTimeout(stepL2, 30 + (j % 4) * 9));
        } else {
          timers.push(setTimeout(stepL3, 220));
        }
      }
      function stepL3() {
        if (k < L3.length) {
          k++; vis.innerHTML = L1 + "<br>" + L2 + "<br>" + L3.slice(0, k);
          timers.push(setTimeout(stepL3, 30 + (k % 4) * 9));
        } else {
          vis.innerHTML = FINAL;
          stage.classList.remove("is-typing");
        }
      }
    }
    function unType() {
      typed = false; clearTimers();
      stage.classList.remove("is-typing");
      vis.innerHTML = "";
    }
  
    function seg(p, a, b) {
      var t = Math.min(Math.max((p - a) / (b - a), 0), 1);
      return t * t * (3 - 2 * t);
    }
    function frame() {
      ticking = false;
      if (mqStack.matches) return;
      var travel = root.offsetHeight - window.innerHeight;
      if (travel <= 0) return;
      var p = Math.min(Math.max(-root.getBoundingClientRect().top / travel, 0), 1);
      var s1 = seg(p, .20, .45);
      stage.style.setProperty("--s1", s1.toFixed(4));
      stage.style.setProperty("--s2", seg(p, .45, .65).toFixed(4));
      stage.style.setProperty("--s3", seg(p, .65, .85).toFixed(4));
      /* type only once the mark is SETTLED at its fixed spot â€” and un-type the
         moment it leaves on the way back, so reversing never shows the line
         hanging beside a travelling icon (annotated bug, 2026-07-31) */
      if (s1 >= .999 && !typed) typeIn();
      else if (s1 < .96 && typed) unType();
    }
    function onScroll() { if (ticking) return; ticking = true; requestAnimationFrame(frame); }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    /* crossing into the stacked layout must never leave a half-typed line */
    mqStack.addEventListener ? mqStack.addEventListener("change", function (e) {
      if (e.matches) { clearTimers(); stage.classList.remove("is-typing"); vis.innerHTML = FINAL; typed = true; }
    }) : null;
    /* wide start: empty until the mark settles, then the line types itself */
    if (!mqStack.matches) vis.innerHTML = "";
    frame();
  })();
  
  (function () {
    "use strict";
    var root = document.querySelector("[data-gphone]");
    if (!root) return;
    var screen = root.querySelector(".gphone__screen");
    if (matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    var typeEl = root.querySelector("[data-gtype]");
    var timerEl = root.querySelector("[data-gtimer]");
    var countEl = root.querySelector("[data-gcount]");
    var countStart = countEl ? countEl.textContent : "1 note this week";
    /* the garden bed behind the phone: each family lights as its stage lands */
    var bed = document.querySelector(".gbg");
    function lit(cls) { if (bed) bed.classList.add(cls); }
    function unlit() { if (bed) bed.className = "gbg"; }
    var NOTE = root.getAttribute("data-gnote") || "Had a garden salad for lunch, slept well, and felt calm after my evening walk.";
    var countAfter = root.getAttribute("data-gcount-after") || "2 notes this week";
    var timeouts = [], running = false;
    function later(fn, ms) { timeouts.push(setTimeout(fn, ms)); }
    function clearAll() { timeouts.forEach(clearTimeout); timeouts = []; }
    function set(s) { screen.setAttribute("data-gscene", s); }
  
    /* the recording runs to 0:15 (was 0:38) so the sheet reads in full before
       the scene moves on */
    function voiceTimer(dur) {
      var t = 0, iv = dur / 15;
      (function tick() {
        timerEl.textContent = "00:" + (t < 10 ? "0" : "") + t;
        if (t >= 15) return;
        t++; later(tick, iv);
      })();
    }
  
    function play() {
      clearAll();
      later(function () { set("garden"); countEl.textContent = countStart; typeEl.textContent = ""; unlit(); }, 0);
      later(function () { set("note"); }, 3400);
      /* no typing animation: the full two-line note appears with the keyboard */
      later(function () { set("typing"); typeEl.textContent = NOTE; }, 6200);
      /* note written â†’ the blue dots come up */
      later(function () { lit("is-dots"); }, 7400);
      later(function () { set("voice"); voiceTimer(3200); }, 9200);
      /* voice note finished â†’ the flowers open */
      later(function () { set("camera"); lit("is-flowers"); }, 12800);
      /* photo captured â†’ the fireflies wake; by save, the whole bed is lit */
      later(function () { set("save"); lit("is-fireflies"); }, 16200);
      later(function () { set("bloom"); }, 19400);
      later(function () {
        countEl.textContent = countAfter;
        countEl.classList.add("pop");
        later(function () { countEl.classList.remove("pop"); }, 700);
      }, 20600);
      later(function () { set("insight"); }, 23600);
      later(play, 28600);
    }
  
    function inView() {
      var r = root.getBoundingClientRect();
      return r.top < window.innerHeight * 0.85 && r.bottom > window.innerHeight * 0.15;
    }
    function start() { if (!running) { running = true; play(); } }
    function stop() { if (running) { running = false; clearAll(); set("garden"); unlit(); } }
  
    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { e.isIntersecting ? start() : stop(); });
      }, { threshold: 0.25 }).observe(root);
      /* Belt and braces: an observer only delivers once the page composites a
         frame, so a tab that is backgrounded or never painted would sit on the
         first scene forever. A geometry check on load and on scroll starts the
         loop regardless. */
      if (inView()) start();
      window.addEventListener("scroll", function () {
        inView() ? start() : stop();
      }, { passive: true });
    } else { play(); }
  })();
  
  (function () {
    "use strict";
    var box = document.querySelector("[data-qty]");
    if (!box) return;
    var out = box.querySelector("output"), input = box.querySelector("[data-qty-input]"), n = 1;
    function set(v) { n = Math.min(Math.max(v, 1), 9); out.textContent = n; if (input) input.value = n; }
    var minusBtn = box.querySelector("[data-qty-minus]");
    var plusBtn = box.querySelector("[data-qty-plus]");
    if (minusBtn) minusBtn.addEventListener("click", function () { set(n - 1); });
    if (plusBtn) plusBtn.addEventListener("click", function () { set(n + 1); });
  })();
  
  (function () {
    "use strict";
    var root = document.querySelector("[data-pgal]");
    if (!root) return;
    var slides = [].slice.call(root.querySelectorAll("[data-pgal-s]"));
    if (slides.length < 2) return;
    var dotBox = root.querySelector("[data-pgal-dots]");
    if (!dotBox) return;
    var dots = [], at = 0;
  
    slides.forEach(function (s, i) {
      var d = document.createElement("button");
      d.type = "button";
      d.className = "pgal__dot" + (i ? "" : " is-on");
      d.setAttribute("role", "tab");
      d.setAttribute("aria-label", "Image " + (i + 1) + " of " + slides.length);
      d.setAttribute("aria-selected", i ? "false" : "true");
      d.addEventListener("click", function () { go(i); });
      dotBox.appendChild(d);
      dots.push(d);
    });
  
    function go(i) {
      at = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle("is-on", k === at); });
      dots.forEach(function (d, k) {
        d.classList.toggle("is-on", k === at);
        d.setAttribute("aria-selected", k === at ? "true" : "false");
      });
    }
  
    var prevBtn = root.querySelector("[data-pgal-prev]");
    var nextBtn = root.querySelector("[data-pgal-next]");
    if (prevBtn) prevBtn.addEventListener("click", function () { go(at - 1); });
    if (nextBtn) nextBtn.addEventListener("click", function () { go(at + 1); });
    root.addEventListener("keydown", function (e) {
      if (e.key === "ArrowLeft") { go(at - 1); }
      else if (e.key === "ArrowRight") { go(at + 1); }
    });
  })();
  
  /* Reserve the family card row at the tallest opened height so hover
     expansion does not grow the section. Mirrors design-20/main.js. */
  (function famReserve() {
    var ul = document.querySelector(".fampeople");
    if (!ul) return;
    var cards = [].slice.call(ul.querySelectorAll(".fcard"));
    if (!cards.length) return;
  
    function measure() {
      ul.style.minHeight = "";
      ul.classList.add("is-measuring");
      var tallest = 0;
      cards.forEach(function (c) {
        var h = c.getBoundingClientRect().height;
        if (h > tallest) tallest = h;
      });
      ul.classList.remove("is-measuring");
      ul.style.minHeight = Math.ceil(tallest) + "px";
    }
  
    measure();
  
    var t;
    function schedule() { clearTimeout(t); t = setTimeout(measure, 150); }
    window.addEventListener("resize", schedule, { passive: true });
  
    if ("ResizeObserver" in window) {
      var lastW = Math.round(ul.getBoundingClientRect().width);
      new ResizeObserver(function () {
        var w = Math.round(ul.getBoundingClientRect().width);
        if (w === lastW) return;
        lastW = w;
        schedule();
      }).observe(ul);
    }
  
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
  })();
  
  /* Sticky Book EYVA button — appears once the hero CTA leaves the viewport. */
  (function fab() {
    var els = document.querySelectorAll("[data-fab]");
    var cta = document.querySelector(".hero--scan .hero__cta") || document.querySelector(".hero__cta");
    if (!els.length || !cta) return;
    els.forEach(function (el) { el.removeAttribute("hidden"); });
  
    function show(on) {
      els.forEach(function (el) { el.classList.toggle("is-in", on); });
    }
  
    if (!("IntersectionObserver" in window)) { show(true); return; }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { show(!e.isIntersecting); });
    }, { rootMargin: "0px 0px -10% 0px" }).observe(cta);
  })();
  
  